import { getEndpointV2 } from 'api';
import { fillPath } from 'helpers/api';

export const getPathToFetchAndAdd = (companyId?: string): string =>
  companyId
    ? fillPath({ path: '/auth/company/:companyId/area', urlParams: { companyId } })
    : fillPath({ path: '/auth/company/area' });

export const getUrlToFetchAndAdd = (companyId?: string): string => {
  return getEndpointV2({ path: getPathToFetchAndAdd(companyId) });
};

export const getPathToUpdateAndRemove = (id: string, companyId?: string): string =>
  companyId
    ? fillPath({
        path: '/auth/company/:companyId/area/:id',
        urlParams: { companyId, id },
      })
    : fillPath({ path: '/auth/company/area/:id', urlParams: { id } });

export const getUrlToUpdateAndRemove = (id: string, companyId?: string): string => {
  return getEndpointV2({
    path: getPathToUpdateAndRemove(id, companyId),
  });
};
